<template>
  <div>
      <div class="get-started-container">
        <h1>Settings</h1>
        <el-form ref="form" :model="form" label-width="120px">
          <el-form-item label="First Name">
            <el-input placeholder="First Name " type="text" v-model="form.firstName" >
            </el-input>
          </el-form-item>
          <el-form-item label="Last Name">
            <el-input placeholder="Last Name " type="text" v-model="form.lastName" >
            </el-input>
          </el-form-item>
          <el-form-item label="Email">
            <el-input placeholder="Email" type="text" v-model="form.email" >
            </el-input>
          </el-form-item>
          <el-form-item label="Gender">
            <el-radio-group v-model="form.resource">
              <el-radio label="Male"></el-radio>
              <el-radio label="Female"></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="Goal Weight">
            <el-input placeholder="Goal at the end of the challenge" v-model="form.goalWeight" class="input-with-select">
              <el-select v-model="form.units" slot="append" placeholder="Units">
                <el-option label="Kg" value="KG"></el-option>
                <el-option label="Lbs" value="LB"></el-option>
              </el-select>
            </el-input>
          </el-form-item>
          <el-form-item label="Profile Picture">
            <el-button type="defaul" @click="onUploadClicked">Upload Image</el-button>
          </el-form-item>
    
          <el-form-item>
            <el-button type="primary" class="get-started-btn" @click="onSubmit">Save</el-button>
          </el-form-item>
        </el-form>
        
      </div>
  </div>
</template>

<script>
export default {
  name: 'start',
  data () {
    return {
      form: {
          name: '',
          region: '',
          date1: '',
          date2: '',
          delivery: false,
          type: [],
          resource: '',
          desc: ''
        },
      savingData: false,
      msg: 'This is the login',
      userData:{
        email:"",
        password:""
      }
    }
  },
  methods:{
    onSubmit:function(){
      this.$router.push('/dashboard/');
    },
    goToSignup:function(){
      this.$router.push('/signup/plan');
    },
    onUploadClicked:function openPicker() {
        window.fsClient.pick({
          fromSources:["local_file_system","imagesearch","facebook","instagram","dropbox"]
        }).then(function(response) {
          // declare this function to handle response
          handleFilestack(response);
        });
    }
  }
}
</script>

<style>
.get-started-container{
  background-color: #FFF;
  width: 100%;
  display: inline-block;
  margin-bottom: 30px;    
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  text-align: left;
}
.get-started-container form {
  max-width: 500px;
  margin:30px auto;
}
.get-started-container h1 {
  width: 100%;
  padding: 20px 30px 5px;
  margin: 0;
  color: #666;
  font-family: prohibition;
  text-align: center;
  font-size: 30px;
  box-sizing: border-box;
}
.get-started-container .el_select {
  width: 100%;
}
.get-started-container a{
  color: #d7347d;
}
.get-started-container p{
  text-align: center;
  color: #666;
}
.article-body {
  padding: 0 30px;
  text-align: left;
  margin-bottom: 30px;
}
.article-body p{
  margin:5px 0 10px;
  color: #999;
  line-height: 26px;

}
.el-input-group__append{
  width: 40px;
}
.get-started-btn {
  width: 100%;
}
</style>
